<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create New Permit</span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Work Entry Permit request Details</span>
    </div>
    <div class="d-flex flex-column mb-3 mb-md-4">
        <span class="cursor-pointer h5 mb-2 mb-md-4 mb-lg-5 mb-md-6">Back</span>
        <div class="d-flex column-gap-2 align-items-center text-warning mb-2 mb-md-4 mb-lg-5"
            *ngIf="status === 'pending'">
            <span class="status_icon bg-warning">
                <svg-icon src="./assets/images/icons/exclamation.svg"></svg-icon>
            </span>
            <span class="cursor-pointer h5 font-weight-medium mb-0">Status Pending</span>
        </div>
        <div class="d-flex column-gap-2 align-items-center text-success mb-2 mb-md-4 mb-lg-5"
            *ngIf="status === 'approved'">
            <span class="status_icon bg-success">
                <svg-icon src="./assets/images/icons/check.svg"></svg-icon>
            </span>
            <span class="cursor-pointer h5 font-weight-medium mb-0">Status Approved</span>
        </div>
        <div class="d-flex column-gap-2 align-items-center text-danger mb-2 mb-md-4 mb-lg-5"
            *ngIf="status === 'declined'">
            <span class="status_icon bg-danger">
                <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
            </span>
            <span class="cursor-pointer h5 font-weight-medium mb-0">Status Declined</span>
        </div>
        <h2 class="font-weight-bold mb-2 mb-md-3">Work Entry Permit Request Details</h2>
        <p class="h4 font-weight-semibold text-primary mb-0">Ref No. 30356894</p>
        <div class="col-12 col-md-8 px-0" *ngIf="!viewOnly && status === 'approved'">
            <div class="bg-primary-light text-primary rounded p-3 p-md-4 p-lg-5 mt-4 mt-md-5 mb-2 mb-md-3">
                <h5>Comments</h5>
                <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt ut labore
                    et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                    commodo consequat. Duis
                    aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
            </div>
        </div>
        <div class="bg-primary-light text-primary font-weight-medium rounded p-3 p-md-4 p-lg-5 mt-4 mt-md-5 mb-2 mb-md-3 h5"
            *ngIf="!viewOnly && status === 'pending' && safetyDocuments">Safety Documents Required</div>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <ngb-accordion [activeIds]="activeIds" class="form_accordion">
            <ngb-panel>
                <ng-template ngbPanelHeader>
                    <div class="accordion-button" [class.collapsed]="!opened">
                        <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                            Vendor Details
                            <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Name</small>
                            <span class="font-weight-medium text-gray-dark">Rajesh Agarwal</span>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel>
                <ng-template ngbPanelHeader>
                    <div class="accordion-button" [class.collapsed]="!opened">
                        <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                            Work Details
                            <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Nature of work</small>
                            <span class="font-weight-medium text-gray-dark">Rajesh Agarwal</span>
                        </div>
                    </div>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Start Date</small>
                            <span class="font-weight-medium text-gray-dark">2 May, 2023</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">End Date</small>
                            <span class="font-weight-medium text-gray-dark">10 May, 2023</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Time Slot</small>
                            <span class="font-weight-medium text-gray-dark">Half Day</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Weekend Inclusion</small>
                            <span class="font-weight-medium text-gray-dark">Yes</span>
                        </div>
                        <div class="col-12 col-md-11 col-lg-10 col-xl-9 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Description of work</small>
                            <span class="font-weight-medium text-gray-dark">Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                                aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                aliquip
                                ex ea commodo consequat. Duis
                                aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur.</span>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel>
                <ng-template ngbPanelHeader>
                    <div class="accordion-button" [class.collapsed]="!opened">
                        <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                            Supervisor Details
                            <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Name</small>
                            <span class="font-weight-medium text-gray-dark">Mukesh Rajput</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Email ID</small>
                            <span class="font-weight-medium text-gray-dark">mukesh.rajput&#64;gmail.com</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Phone Number</small>
                            <span class="font-weight-medium text-gray-dark">9876589632</span>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel>
                <ng-template ngbPanelHeader>
                    <div class="accordion-button" [class.collapsed]="!opened">
                        <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                            Location Details
                            <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Building</small>
                            <span class="font-weight-medium text-gray-dark">Victor</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Floor Number</small>
                            <span class="font-weight-medium text-gray-dark">4</span>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Unit</small>
                            <span class="font-weight-medium text-gray-dark">241</span>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel>
                <ng-template ngbPanelHeader>
                    <div class="accordion-button" [class.collapsed]="!opened">
                        <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                            Worker Details
                            <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Number of Workers</small>
                            <span class="font-weight-medium text-gray-dark">{{workers.length}}</span>
                        </div>
                    </div>
                    <div class="row row-gap-4 mb-3 mb-md-4">
                        <div class="col-12 col-md-6 col-lg-4" *ngFor="let worker of workers">
                            <div class="border border-light rounded-lg p-3">
                                <div class="d-flex justify-content-between mb-3">
                                    <h5>Worker {{worker.workerId}}</h5>
                                </div>
                                <div
                                    class="alert alert-info border-info d-flex align-items-center justify-content-center small">
                                    <div class="px-3 border-right border-light">
                                        Entry Time: <span
                                            class="font-weight-semibold text-primary">{{worker.entryTime}}</span>
                                    </div>
                                    <div class="px-3">
                                        Exit Time: <span
                                            class="font-weight-semibold text-primary">{{worker.exitTime}}</span>
                                    </div>
                                </div>
                                <div class="row row-gap-4 mb-4 mb-md-5">
                                    <div class="col-12 d-flex flex-column row-gap-2">
                                        <small class="font-weight-light text-gray-medium">Name</small>
                                        <span class="font-weight-medium text-gray-dark">{{worker.name}}</span>
                                    </div>
                                    <div class="col-12 d-flex flex-column row-gap-2">
                                        <small class="font-weight-light text-gray-medium">Phone Number</small>
                                        <span class="font-weight-medium text-gray-dark">{{worker.phoneNumber}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>

        <ng-container *ngIf="!viewOnly">
            <div
                class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
                <h3 class="font-weight-semibold mb-0">Mark as Critical</h3>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="markCriticalSwitch"
                        formControlName="markCriticalSwitch">
                    <label class="custom-control-label" for="markCriticalSwitch"></label>
                </div>
            </div>
            <div class="d-flex flex-wrap row-gap-3 column-gap-4 column-gap-lg-5 column-gap-xl-6"
                *ngIf="myForm.get('markCriticalSwitch').value === true">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="hotWork" name="markCritical" class="custom-control-input">
                    <label class="custom-control-label font-weight-semibold" for="hotWork">Hot Work</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="heightWork" name="markCritical" class="custom-control-input">
                    <label class="custom-control-label font-weight-semibold" for="heightWork">Height Work</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="confinedSpace" name="markCritical" class="custom-control-input">
                    <label class="custom-control-label font-weight-semibold" for="confinedSpace">Confined Space</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="electricalWork" name="markCritical" class="custom-control-input">
                    <label class="custom-control-label font-weight-semibold" for="electricalWork">Electrical
                        Work</label>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="viewOnly">
            <div
                class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
                <h3 class="font-weight-semibold mb-0">Marked as Critical</h3>
            </div>
            <div class="d-flex flex-wrap column-gap-4 row-gap-3">
                <span class="font-weight-semibold">Hot Work</span>
            </div>
        </ng-container>

        <div class="border-top pt-5 pt-md-6 mt-5 mt-md-6" *ngIf="!viewOnly">
            <ngb-accordion [activeIds]="activeIds" class="form_accordion">
                <ngb-panel>
                    <ng-template ngbPanelHeader>
                        <div class="accordion-button" [class.collapsed]="!opened">
                            <button class="h5 mb-2 mb-md-3 mb-lg-4" ngbPanelToggle>
                                Safety Documents
                                <svg-icon src="./assets/images/icons/chevron_up.svg"></svg-icon>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="row row-gap-4 mb-4 mb-md-5">
                            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                                <small class="font-weight-light text-gray-medium">Document 1</small>
                                <span class="font-weight-medium text-gray-dark">work-procedure.pdf</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                                <small class="font-weight-light text-gray-medium">Document 2</small>
                                <span class="font-weight-medium text-gray-dark">method-statement.doc</span>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div
            class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
            <!-- view mode start -->
            <button class="btn btn-clear" type="button" *ngIf="viewOnly">Cancel</button>
            <button class="btn btn-primary" type="button" (click)="goToEditPage()" *ngIf="viewOnly">Edit</button>
            <!-- view mode end -->

            <!-- approve mode start -->
            <button class="btn btn-clear" type="button" *ngIf="!viewOnly" (click)="goToAnotherSMEPage()">Assign Another
                SME</button>
            <button class="btn btn-clear text-danger" type="button" (click)="openRemoveModal('')"
                *ngIf="!viewOnly">Decline</button>
            <button class="btn btn-primary" type="submit" *ngIf="!viewOnly">Approve</button>
            <!-- approve mode end -->
        </div>
    </form>
</div>